var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4750_40552)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 17,
    fill: "#C50F1F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4750_40552)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15.6522,
    transform: "translate(15 12)",
    fill: "#C50F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3281 13.5774L22.7344 14.4457H27.2656L26.6719 13.5774C26.625 13.5102 26.5469 13.4674 26.4625 13.4674H23.5344C23.45 13.4674 23.3719 13.5071 23.325 13.5774H23.3281ZM27.9219 12.7643L29.0688 14.4457H29.5H31H31.25C31.6656 14.4457 32 14.7728 32 15.1793C32 15.5859 31.6656 15.913 31.25 15.913H31V25.2065C31 26.5577 29.8813 27.6522 28.5 27.6522H21.5C20.1188 27.6522 19 26.5577 19 25.2065V15.913H18.75C18.3344 15.913 18 15.5859 18 15.1793C18 14.7728 18.3344 14.4457 18.75 14.4457H19H20.5H20.9313L22.0781 12.7612C22.4031 12.2874 22.95 12 23.5344 12H26.4625C27.0469 12 27.5938 12.2874 27.9187 12.7612L27.9219 12.7643ZM20.5 15.913V25.2065C20.5 25.7476 20.9469 26.1848 21.5 26.1848H28.5C29.0531 26.1848 29.5 25.7476 29.5 25.2065V15.913H20.5ZM23 17.8696V24.2283C23 24.4973 22.775 24.7174 22.5 24.7174C22.225 24.7174 22 24.4973 22 24.2283V17.8696C22 17.6005 22.225 17.3804 22.5 17.3804C22.775 17.3804 23 17.6005 23 17.8696ZM25.5 17.8696V24.2283C25.5 24.4973 25.275 24.7174 25 24.7174C24.725 24.7174 24.5 24.4973 24.5 24.2283V17.8696C24.5 17.6005 24.725 17.3804 25 17.3804C25.275 17.3804 25.5 17.6005 25.5 17.8696ZM28 17.8696V24.2283C28 24.4973 27.775 24.7174 27.5 24.7174C27.225 24.7174 27 24.4973 27 24.2283V17.8696C27 17.6005 27.225 17.3804 27.5 17.3804C27.775 17.3804 28 17.6005 28 17.8696Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4750_40552",
    x: 0.8,
    y: 2.38419e-7,
    width: 48.4,
    height: 48.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4750_40552"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4750_40552",
    result: "effect2_dropShadow_4750_40552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4750_40552",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4750_40552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15.6522,
    fill: "white",
    transform: "translate(15 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFile);
export default __webpack_public_path__ + "static/media/deleteFile.761aec68ccb6584d9a641291b033d9b5.svg";
export { ForwardRef as ReactComponent };